import React from 'react';
import { Flex, Typography } from 'antd';
import { RightOutlined } from '@ant-design/icons';
import { ActionButton, BackButton, CenteredContainer, GridContainer } from 'common/components/UI';
import classes from './TopUp.module.scss';
import { useNavigate} from 'react-router-dom';
import { ROUTES } from 'common/components/AppRouter/AppRouter';
import EuroIcon from 'common/components/icons/Euro';
import CardIcon from 'common/components/icons/Card';
import { useIntl } from 'react-intl';
import SendIcon from '../../../common/components/icons/Send';

const { Title } = Typography;

const Index: React.FC = () => {
  const navigate = useNavigate();
  const { formatMessage: t } = useIntl();

  return (
    <GridContainer>
      <div className={classes['wrapper']}>
        <BackButton/>
        <Flex gap="middle" vertical>
          <Title level={3}>{t({ id: 'sections.load.load.header' })}</Title>
          <Flex gap="middle" vertical>
            <ActionButton
              icon={<RightOutlined />}
              prefix={
                <div className={classes['icon-container']}>
                  <EuroIcon className={classes['icon']} />
                </div>
              }
              text={t({ id: 'sections.load.load.tabs.sepa' })}
              onClick={() => navigate(ROUTES.OCEAN_TOP_UP_SEPA.path)}
            />
            <ActionButton
              icon={<RightOutlined />}
              prefix={
                <div className={classes['icon-container']}>
                  <CardIcon className={classes['icon']} />
                </div>
              }
              text={t({ id: 'sections.load.load.tabs.bank' })}
              onClick={() => navigate(ROUTES.OCEAN_TOP_UP_BY_BANK.path)}
            />
            <ActionButton
              icon={<RightOutlined />}
              prefix={
                <div className={classes['icon-container']}>
                  <SendIcon className={classes['icon']} />
                </div>
              }
              text={t({ id: 'sections.load.invoice.title' })}
              onClick={() => navigate(ROUTES.OCEAN_TOP_UP_INVOICE.path)}
            />
          </Flex>
        </Flex>
      </div>
    </GridContainer>
  );
};

export default Index;
